import { Container, Navbar } from "react-bootstrap";

export default function Header(){
  return(
    <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href="#home">
            SpesaIO
          </Navbar.Brand>
        </Container>
      </Navbar>
  )
}
